// src/api/ReservationService.ts
import apiClient from "./ApiClient";
import { Reservation } from "../models/StaticDataModel";
import { setToken } from "../services/AuthService";

/** Store guest check-in session JWT for subsequent authenticated /checkin calls. */
export const applyCheckInSessionFromReservation = (reservation: Reservation): void => {
    if (reservation.checkInAccessToken && reservation.checkInAccessTokenExpiresIn != null) {
        setToken(reservation.checkInAccessToken, reservation.checkInAccessTokenExpiresIn);
    }
};

/** confirmationNo: Opera INTERNAL confirmation or external / CRS reference (backend tries both). */
export const fetchReservation = async (
    lastName: string,
    confirmationNo: string
): Promise<Reservation> => {
    const response = await apiClient.get("/reservations", {
        params: { lastName, confirmationNo },
    });
    const data = response.data as Reservation;
    applyCheckInSessionFromReservation(data);
    return data;
};

/** Optional: tiny validator for "HH:mm" */
export const isValidEta = (eta: string) => /^\d{2}:\d{2}$/.test(eta);

/**
 * Modify booking ETA (SOAP ModifyBooking)
 * POST /reservations/{confirmationNumber}/modify-booking
 * Body: { hotelId, eta }  // eta as "HH:mm"
 */
export const modifyBookingEta = async (
  confirmationNumber: string,
  hotelId: string,
  eta: string
) => {
  // (keep validation in UI ideally; this is just defensive)
  if (!confirmationNumber) throw new Error("Missing confirmation number");
  if (!hotelId) throw new Error("Missing hotelId");
  if (!isValidEta(eta)) throw new Error("ETA must be in HH:mm format");

  const res = await apiClient.post(
    `/reservations/${encodeURIComponent(confirmationNumber)}/modify-booking`,
    { hotelId, eta }
  );
  return res.data; // shape depends on your backend
};
